import styled from "@emotion/styled"

export const Section = styled.section`
  margin: 8rem 0;
`
